import React from 'react';
import { ComboBox } from '@/components/UI';

interface ExportTypeComboProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  reportKey?: 'DEFAULT_REPORT' | string;
}

const optionsByKey: Record<string, Array<{ value: string; label: string }>> = {
  INSTRUCTOR_REPORT: [
    { value: 'pdf', label: 'PDF' },
    { value: 'excel', label: 'Excel' },
    { value: 'print', label: 'Print' },
    { value: 'summary-pdf', label: 'Summary in Pdf' },
    { value: 'summary-excel', label: 'Summary in Excel' }
  ],
  HOTEL_AGENT_REPORT: [
    { value: 'pdf', label: 'PDF' },
    { value: 'excel', label: 'Excel' },
    { value: 'print', label: 'Print' },
    { value: 'summary-pdf', label: 'Summary in Pdf' },
    { value: 'summary-excel', label: 'Summary in Excel' }
  ],
  HOTEL_AGENT_REPORT_DETAIL: [
    { value: 'pdf', label: 'PDF' },
    { value: 'excel', label: 'Excel' }
  ],
  GROUP_LESSON_REPORT: [
    { value: 'pdf', label: 'PDF' },
    { value: 'excel', label: 'Excel' },
    { value: 'print', label: 'Print' }
  ],
  STAFF_REPORT: [
    { value: 'pdf', label: 'PDF' },
    { value: 'excel', label: 'Excel' },
    { value: 'print', label: 'Print' }
  ],
  TRANSPORT_REPORT: [
    { value: 'pdf', label: 'PDF' },
    { value: 'excel', label: 'Excel' },
    { value: 'print', label: 'Print' }
  ],
  DEFAULT_REPORT: [
    { value: 'pdf', label: 'PDF' },
    { value: 'excel', label: 'Excel' },
    { value: 'print', label: 'Print' }
  ]
};

const ExportTypeCombo: React.FC<ExportTypeComboProps> = ({
  value,
  onChange,
  className,
  reportKey
}) => {
  const exportTypeOptions =
    optionsByKey[reportKey || 'DEFAULT_REPORT'] || optionsByKey.DEFAULT_REPORT;
  return (
    <ComboBox
      value={value}
      onChange={val => onChange(String(val))}
      options={exportTypeOptions}
      className={className || 'w-40 max-w-xs min-w-[120px]'}
    />
  );
};

export default ExportTypeCombo;
